import { Box } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { SubmitHandler, useForm } from "react-hook-form";
import { AuthContext } from "../../contexts/AuthContext";
import { IColor } from "../../interfaces/IColor";
import { CONFIG } from "../../services/config";
import { FormInputText } from "../form/FormInputText";
import ActionButtons from "../MyModal/ActionButtons";

export default function AddColor({ watchDataChange, messageError, data }: any) {
  const { t } = useTranslation();
  const {
    tokenHeaders,
    country: { countryCode },
  } = useContext(AuthContext);

  const addFormData = yup.object().shape({
    name: yup.string().required(t("colors.Required name")),
    code: yup.string().required(t("colors.Required code")),
    // active: yup.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IColor>({ resolver: yupResolver(addFormData) as any }); // Add interface IColor

  const addColor: SubmitHandler<IColor> = async (values) => {
    // Add interface IColor
    console.log("values", values);

    try {
      await axios.post(
        `${CONFIG.API_URL}vehiclecolors`,
        {
          name: values.name,
          colorCode: values.code,
          countryCode,
        },
        tokenHeaders,
      );
    } catch (error: any) {
      return messageError(error.response.data.message);
    }
    watchDataChange(t("colors.colorAdded"));
  };

  return (
    <Box component="form" onSubmit={handleSubmit(addColor)}>
      <FormInputText
        label={t("colors.code")}
        error={errors.code}
        {...register("code")}
        inputProps={{
          maxLength: 4,
          minLength: 4,
        }}
      />
      <FormInputText
        label={t("colors.name")}
        error={errors.name}
        {...register("name")}
      />

      {/* <FormGroup sx={{ marginBottom: "1rem" }}>
        <FormControlLabel
          control={
            <Switch id="isCognitive" {...register("active")} defaultChecked />
          }
          label={t("colors.active")}
        />
      </FormGroup> */}

      <ActionButtons saveName={t("button.Add")} typeButton="submit" />
    </Box>
  );
}
